import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as supplierActions from "../../../../../actions/supplierAction";
import * as SupplierCategoryAction from "../../../../../actions/supplierCategoryAction";
import RateCodeUsagePlanDetail from "./RateCodeUsagePlanDetail";
import * as RateCodeAction from './../../../../../actions/rateCodeAction';

const mapStateToProps = (state) => {
  return {
    rateCodeState: state.rateCodeReducer.rateCodeDetail,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getRateCodeDetail: (id) => dispatch(RateCodeAction.getRateCodeDetail(id)),
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(RateCodeUsagePlanDetail)
);
